import { Component } from '@angular/core';
import { Platform, NavController, ToastController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { StatusBar } from '@ionic-native/status-bar';
//import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook';

import { Storage } from '@ionic/storage';

import { BusinessMainPage } from '../../pages/business-main/business-main';
import { ConsumerMainPage } from '../../pages/consumer-main/consumer-main';
import { StamperMainPage } from '../../pages/stamper-main/stamper-main';
import { CashierMainPage } from '../../pages/cashier-main/cashier-main';
import { ExpeditorMainPage } from '../../pages/expeditor-main/expeditor-main';
import { RegisterPage } from '../../pages/register/register';
import { BusinessRegisterPage } from '../../pages/business-register/business-register';
import { ChangePasswordPage } from '../../pages/change-password/change-password';

import { AuthProvider } from '../../providers/auth';
import { PushNotificationHandlerProvider } from '../../providers/push-notification-handler';

declare var FB: any;

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  loginForm : FormGroup;

  isLogginIn: boolean = false;
  isLogginInToFacebook: boolean = false;

  recievedError: boolean = false;

  hasCordova: boolean = false;

  constructor(
              public platform: Platform, 
              public statusBar: StatusBar,   
              public navCtrl: NavController,
              public formBuilder: FormBuilder,
              public toastCtrl: ToastController,
              public storage: Storage,  
              public authProvider: AuthProvider,
              //public fb: Facebook,
              private pushNotificationHandlerProvider: PushNotificationHandlerProvider,
              ) {    

    this.loginForm = this.formBuilder.group({
      "grant_type": ['password'],
      "username":  ['', Validators.required],
      "password":  ['', Validators.required],
     });      

    this.platform.ready().then((readySource) => {
      if(readySource!="dom"){
        this.hasCordova = true;
      }
    });

    this.statusBar.styleDefault();
  }

  doFacebookLogin(){
    // if(this.isLogginInToFacebook) return;

    // this.platform.ready().then((readySource) => {
    //   if(readySource=="dom"){
    //     FB.login(function(response){
    //        var i = response;
    //     });
    //   }else{       
    //     this.isLogginInToFacebook = true;

    //     console.log('Loggin into Facebook!')

    //     this.fb.login(['public_profile', 'email'])
    //       .then(
    //         (res: FacebookLoginResponse) => {
    //           console.log('Logged into Facebook!', res.authResponse.accessToken)

    //           this.authProvider.fbLogin(res.authResponse.accessToken).then(
    //             (data)=>{
    //                 this.isLogginInToFacebook =false;

    //                 this.navCtrl.setRoot(ConsumerMainPage);        
    //             }
    //           );   
    //         }
    //       )
    //       .catch(
    //         (e) =>{
    //           this.isLogginInToFacebook =false;
              
    //           console.log('Error logging into Facebook', e)
    //         }
    //       );        
    //   }

    // })
  }

  // Attempt to login in through our User service
  doLogin() {
    if(this.isLogginIn) return;

    this.isLogginIn = true;
    this.recievedError = false;

    this.authProvider.login(this.loginForm.value)
    .then( data => {        
        if(data=="Consumer"){           
          this.navCtrl.setRoot(ConsumerMainPage);   
        } else if(data=="Stamper"){
          this.navCtrl.setRoot(StamperMainPage);                   
        } else if(data=="Cashier"){
          this.navCtrl.setRoot(CashierMainPage);
        } else if(data=="Expeditor"){
          this.navCtrl.setRoot(ExpeditorMainPage);
        } else{
          this.navCtrl.setRoot(BusinessMainPage);                                 
        }     

        this.pushNotificationHandlerProvider.subsribeUserByRole(data);
        
        setTimeout(()=>{
          this.isLogginIn =false;
        }, 1000)        
    })
    .catch( error => {
        this.isLogginIn = false;
        this.recievedError = true;
        console.log(error)
    })
  }

  changePassword(){
    this.navCtrl.push(ChangePasswordPage);
  }

  moveToRegister(){  
    this.navCtrl.push(RegisterPage);
  }  

  moveToRegisterBusiness(){
    this.navCtrl.push(BusinessRegisterPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts